import { render, staticRenderFns } from "./AppPrograma.vue?vue&type=template&id=1f8a931f&"
import script from "./AppPrograma.vue?vue&type=script&lang=ts&"
export * from "./AppPrograma.vue?vue&type=script&lang=ts&"
import style0 from "./AppPrograma.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports